import React from "react";
import Layout from "../components/Layout/Layout";
import BannerHeroSection from "../components/HeroSection/BannerHeroSection";
import HeroSectionImage from "../assets/privateContactBanner.png";
import FAQ from "../components/Homepage/FAQ";

const PrivateContact = () => {
  return (
    <Layout>
      <BannerHeroSection
        title="Private Class Booking"
        subtitle="Book personalized training sessions for your team or organization"
        bannerImage={HeroSectionImage}
        height="h-64 md:h-80 lg:h-96 xl:h-[500px]"
        className="-mx-4 md:-mx-12 lg:-mx-16 mb-6 md:mb-8 lg:mb-10"
      />
      <FAQ />
    </Layout>
  );
};

export default PrivateContact;
